import { render, staticRenderFns } from "./AccordionNav.vue?vue&type=template&id=5cb76038&"
import script from "./AccordionNav.vue?vue&type=script&lang=js&"
export * from "./AccordionNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports